import * as React from 'react'
import { DownTime } from '../../../model/DownTime'
import ScadaObject from '../../../model/ScadaObject'
import { LockStatus } from '../../../model/DownTimeEnums'

type Props = {
  replaceDowntime: Function
  downTime: DownTime
  scadaObjects: ScadaObject[]
}

export class ScadaObjectCell extends React.Component<Props> {
  render(): JSX.Element {
    if (this.props.downTime.isNew && this.props.downTime.lockStatus === LockStatus.notLocked) {
      return (
        <select
          value={this.props.downTime.scadaObjectKey}
          onChange={e => {
            const key = e.target.value
            const scadaObject = this.props.scadaObjects.find(s => s.apiKey === key)
            this.props.replaceDowntime(
              new DownTime({
                ...this.props.downTime,
                scadaObjectKey: key,
                scadaObjectName: scadaObject ? scadaObject.name : 'unknown'
              })
            )
          }}
          className="form-control"
        >
          {this.props.scadaObjects &&
            this.props.scadaObjects.map(scadaObject => (
              <option value={scadaObject.apiKey} key={scadaObject.apiKey}>
                {scadaObject.name}
              </option>
            ))}
        </select>
      )
    } else {
      return <span className="wordwrap">{this.props.downTime.scadaObjectName.toLocaleLowerCase()}</span>
    }
  }
}

export default ScadaObjectCell
